import React from "react";
import VacancyAlert from "./VacancyAlert";
const Fundraising = () => {
  return (
    <div className="col s12 homeWrapper">
      <VacancyAlert />
      <h5 className="blue-text text-lighten-2">Fundraising</h5>
      <p className="grey-text text-darken-2">
        We are a registered charity preschool and we organise various
        fundraising events such as Peddle for preschool, World Book Day,
        Alphabet Collects, Summer Tambola, Brick and Brack sale and Raffles.
        Those are aimed to involve parents and children to take part in
        preschool establishment.
      </p>
    </div>
  );
};
export default Fundraising;
